//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ItemType
import com.tixforgigs.apax.models.Resale

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The shop resale data model
* 
* @param availableItemTypes The available item types for this resale
* @param isCurrentUserResaleOwner flag if the current user is ticket owner
* @param reserved Bool if the resale is currently reserved
* @param `data` 
* @param floorPlanInfo The floor plan info
* @param resaleToken The resale token for anonymous user
*/
@Serializable

data class ShopResale (


      /* The available item types for this resale */
    @SerialName(value = "availableItemTypes") @Required val availableItemTypes: kotlin.collections.List<ItemType>,


      /* flag if the current user is ticket owner */
    @SerialName(value = "isCurrentUserResaleOwner") @Required val isCurrentUserResaleOwner: kotlin.Boolean,


      /* Bool if the resale is currently reserved */
    @SerialName(value = "reserved") @Required val reserved: kotlin.Boolean,


      @SerialName(value = "data") val `data`: Resale? = null,


      /* The floor plan info */
    @SerialName(value = "floorPlanInfo") val floorPlanInfo: kotlin.String? = null,


      /* The resale token for anonymous user */
    @SerialName(value = "resaleToken") val resaleToken: kotlin.String? = null


) {




  }

